import isEmail from 'validator/lib/isEmail';
import isMobilePhone from 'validator/lib/isMobilePhone';

const fields = [
    {
        type: 'text',
        name: 'Name*',
        className: 'col-span-1',
        placeholder: 'Ben Conley',
        options: {
            required: true,
        }
    },
    {
        type: 'text',
        name: 'Organisation name*',
        className: 'col-span-1',
        placeholder: 'Groundcrew',
        options: {
            required: true,
        }

    },
    {
        type: 'text',
        name: 'Email Address*',
        className: 'col-span-1',
        placeholder: 'BenConley@groundcrew.com.au',
        options: {
            required: true,
            validate: (email) => isEmail(email)
        }
    },
    {
        type: 'text',
        name: 'Phone number*',
        className: 'col-span-1',
        placeholder: '865 698 781',
        options: {
            required: true,
            validate: (phone) => isMobilePhone(phone)
        }
    },
    {
        type: 'toggle',
        name: 'Do you have a defined budget?*',
        className: 'col-span-2',
        nested: {
            defaultValue: false,
            nestedClassName: 'col-span-2',
            fields: [
                {
                    type: 'text',
                    name: 'Please describe your budget',
                    placeholder: 'Please describe your budget',
                    className: 'col-span-2',
                }
            ]
        }

    },
    {
        type: 'toggle',
        name: 'Do you have a defined time-frame?*',
        className: 'col-span-2',
        nested: {
            defaultValue: false,
            nestedClassName: 'col-span-2',
            fields: [
                {
                    type: 'text',
                    name: 'Please describe the timeframe',
                    placeholder: 'Please describe the timeframe',
                    className: 'col-span-2',
                }
            ]
        }

    },
    {
        type: 'text',
        name: 'How did you hear about us?',
        className: 'col-span-2',
        placeholder: 'How did you hear about us?',
        options: {
            required: false,
        }
    },
    {
        type: 'textarea',
        name: 'How can we help?',
        className: 'col-span-2',
        placeholder: 'Please give us a quick run-down of what you need.',
        options: {
            required: false,
        }
    },

]





export default fields